enum Filter {
  catalog = 'catalog',
  searchQuery = 'searchQuery',
  mastersSectionContent = 'mastersSectionContent',
}

export default Filter;
